module.exports = __webpack_public_path__ + "static/media/linkedin.d3bfdd4f.svg";